import 'bootstrap/dist/css/bootstrap.min.css'
import DataTable from 'react-data-table-component'
import {Container, Row, Col, Button} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { TextInput } from '../Misc/FormInput'
import TableStyle from '../Misc/TableStyle'
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';

const BrandTable = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Link',
            selector: row => row.link,
            sortable: true
        }
        /*{
            //button: true,
            sortable: false,
            cell: row => <Link 
                    to={{pathname: "/edit_brand", name: row.name, link: row.link}}
                    style={{backgroundColor: "#E9E9ED", color: "#000000", textDecoration: "underline #000000", padding: "5px 10px"}}>Edit</Link>,
        },*/
        /*{
            //button: true,
            sortable: false,
            cell: row => <button style={{backgroundColor: '#a73c21', textDecoration: 'underline #ffffff', color: '#ffffff', border: 'none', padding: 5}} onClick={() => delete_brand(row.id)}>Delete</button>
        }*/
    ]

    const [brands, setBrands] = useState([]);
    useEffect(() => {
        authFetch(instance, '/api/fetch_brands')
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setBrands(data);
            }).catch(function(error) {
                alert('There was an error connecting to the database, please refresh the page.');
            });
    }, []);

    const [searchTerm, setSearchTerm] = useState('');


    return (
        <Container>
            <Row>
                <Col xs={4} className="text-start">
                    <h2>Brands</h2>
                </Col>
                <Col xs={2} className="text-end align-self-center offset-6 d-grid">
                {/*<Link to={{pathname: "/edit_brand", state: {"id": null, "name": "", "link": ""}}}}
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", padding: "5px 10px"}}>Create New Brand</Link>*/}
                {/*<button
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", padding: "5px 10px"}}
                    onClick={() => navigate('/edit_brand', {state: {id: null, name: "", link: ""}})}
                >Create New Brand</button>*/}
                <Button
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", borderRadius: "0px",
                    borderColor: "#a73c21"}}
                    onClick={() => navigate('/edit_brand', {state: {id: null, name: "", link: ""}})}
                >Create New Brand</Button>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={6} className="text-end">
                <TextInput placeholder="Start typing to filter brands..." inputName="searchTerm" inputLabel="Filter:" inputValue={searchTerm} changeFunc={(event) => setSearchTerm(event.target.value)}/>
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={brands.filter((brand) => {
                    if (searchTerm === "") {
                      return brand;
                    } else if (brand.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return brand;
                    } else {
                        return null;
                    }
                })}
                pagination
                highlightOnHover
                striped
                customStyles={TableStyle}
                onRowClicked={(row) => {
                    navigate('/edit_brand', {state: {id: row.id, name: row.name, link: row.link}});
                }}
            />
        </Container>
    );
}
 
export default BrandTable;